import { DashboardPage } from '@infuse/e-connector/dashboard/pages';
import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';

export const DashboardFeaturePlugin: Plugin = {
  install() {
    AppRouter.addRoute('main', {
      path: '/dashboard',
      component: InfusePageView,
      meta: {
        name: 'nav.dashboard',
        icon: 'dashboard',
        group: 'nav.nav-group.activity'
      },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: DashboardPage
        }
      ]
    });
  }
};
